import {useRef, useState } from "react";
import { toast, Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import axios from 'axios';

import { ButtonLoading } from "../../../components/buttons/button-loading";
import {
  ROUTES,
  HOST_GROWME,
} from "../../../helpers/constants";
import { MailIcon } from "../../../assets/icons";
import SliderLogin from "../../../components/sliders/slider-login";
import InputPass from "../../../components/inputs/input-pass";

const instructionsBeforeSendCode =
  "Ingresa el correo que usaste para unirte a la plataforma y te enviaremos un código para reiniciar tu contraseña.";

const instructionsAfterSendCode =
  "Enviamos un código para que puedas recuperar tu cuenta. Ingresa el código para reestablecer tu contraseña.";
const instructionsTextCodeWrong =
  "Código ingresado incorrecto. Por favor solicita un reenvío de código.";
const instructionTextCode =
  "Al validar tu código puedes ingresar tu nueva contraseña";

const initialFormState = {
  username: "",
  new_password: "",
};

const initialCode = Array(6).fill("");
const RecoverPass = () => {
  let navigate = useNavigate();
  const goBack = () => navigate(-1);
  const [instructions, setInstructions] = useState(false);
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState(initialCode);
  const inputRefs = useRef([]);
  const [isError, setIsError] = useState(false);
  const [formData, setFormData] = useState(initialFormState);

  const onChange = (e) => {
    setFormData((prevValues) => ({
      ...prevValues,
      [e.target.name]: e.target.value,
    }));
  };

  const handleChange = (e, index) => {
    const newOtp = [...otp];
    newOtp[index] = e.target.value;
    setOtp(newOtp);
    if (e.target.value !== "" && index < otp.length - 1) {
      inputRefs.current[index + 1].focus();
    }
    setFormData((prevValues) => ({
      ...prevValues,
      code: otp,
    }));
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "" && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("Text");
    const pasteValues = pasteData.split("").slice(0, otp.length);

    const newOtp = [...otp];
    pasteValues.forEach((value, index) => {
      if (inputRefs.current[index]) {
        newOtp[index] = value;
      }
    });
    setOtp(newOtp);
  };

  const handleSubmitRecover = async (e) => {
    e.preventDefault();
    const { username } = formData;
    setLoading(true);

    try {
      const response = await axios.post(`${HOST_GROWME}/forgotPassword`, {
        username: username
      });

      if (response.data.success) {
        setInstructions(true);
        toast.success("Código enviado exitosamente.");
      } else {
        toast.error(response.data.message || "Error al enviar el código");
      }
    } catch (error) {
      const message = error.response?.data?.message || 
                     error.message || 
                     "Error al enviar el código. Por favor intente nuevamente.";
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitCode = async (e) => {
    e.preventDefault();
    const { username, new_password } = formData;
    const code = otp.join("");
    setLoading(true);

    try {
      const response = await axios.post(`${HOST_GROWME}/confirmPassword`, {
        username: username,
        confirmationCode: code,
        newPassword: new_password
      });

      if (response.data.success) {
        toast.success("Contraseña actualizada exitosamente");
        navigate(ROUTES.LOGIN.route);
      } else {
        toast.error(response.data.message || "Error al actualizar la contraseña");
        setIsError(true);
      }
    } catch (error) {
      const message = error.response?.data?.message || 
                     error.message || 
                     "Error al actualizar la contraseña. Por favor intente nuevamente.";
      toast.error(message);
      setIsError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="gm-container-login">
      <div className="gm-form-container">
        <div className="gm-form-section">
          <Toaster />
          <div className="gm-login-welcome-container">
            <h1>
              {instructions ? "Revisa tu buzón" : "Recupera tu contraseña"}
            </h1>
            <span>
              {instructions
                ? instructionsAfterSendCode
                : instructionsBeforeSendCode}
            </span>
          </div>
          <form
            className="gm-login-form-container"
            onSubmit={instructions ? handleSubmitCode : handleSubmitRecover}
          >
            <div
              className="gm-login-form-group"
              style={{ flexDirection: "column" }}
            >
              {!instructions && (
                <label htmlFor="email">
                  <input
                    className="gm-input-form-section"
                    id="username"
                    name="username"
                    type="username"
                    placeholder="Correo Electrónico"
                    required
                    onChange={onChange}
                  />
                  <MailIcon />
                </label>
              )}
              {instructions && (
                <div className="gm-code-container">
                  <section>
                    {otp.map((digit, index) => (
                      <input
                        className={
                          isError ? "gm-code-invalid" : "gm-code-valid"
                        }
                        key={index}
                        type="text"
                        maxLength={1}
                        value={digit}
                        onChange={(e) => handleChange(e, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        onPaste={handlePaste}
                        ref={(ref) => (inputRefs.current[index] = ref)}
                        required
                        name="code"
                        id="code"
                      />
                    ))}
                  </section>
                  {isError && (
                    <span className="gm-span-error">{instructionsTextCodeWrong} </span>
                  )}
                  <span className="gm-span-login"> {instructionTextCode} </span>
                  <InputPass
                    className="gm-input-form-section"
                    placeholder="Nueva Contraseña"
                    id="new_password"
                    name="new_password"
                    required
                    onChange={onChange}
                  />
              {formData.new_password.length >=1 &&  formData.new_password.length < 8 &&(
                <span className="gm-span-new-pass">Se requiere un mínimo de 8 carácteres</span>
              )}
                </div>
              )}
            </div>
            <div className="gm-login-buttons">
              <ButtonLoading
                className="gm-button-login-section"
                type="submit"
                buttonLabel={instructions ? "Confirmar" : "Enviar Código"}
                disabled={loading || instructions ? (formData.new_password.length < 8) : false}
                loading={loading}
              />
            </div>
              <footer className="gm-footer-login">
                <button
                  onClick={() => {
                    goBack();
                  }}
                >
                  {instructions ? "Volver a Inicio de Sesión" : "Iniciar Sesión"}
                </button>
              </footer>
            {isError && (
              <footer className="gm-footer-login">
                <button
                  onClick={() => {
                    setInstructions(false);
                    setIsError(false);
                    setOtp(initialCode);
                  }}
                >
                  Reenviar Código
                </button>
              </footer>
            )}
          </form>
        </div>
      </div>
      <div className="gm-slider-container">
        <SliderLogin />
      </div>
    </div>
  );
};

export default RecoverPass;
